"use client";

import { useQuery } from "@tanstack/react-query";
import type { GetThoughtsRequest } from "@/generated/fastapi";
import { useAuth } from "@/state/globalStore";
import { getThoughts } from "../api/getThoughts";
import { thoughtKeys } from "./keys";

export default function useThoughtsQuery(
  request: GetThoughtsRequest,
  { enabled = true }: { enabled?: boolean } = {},
) {
  const { accessToken } = useAuth();

  return useQuery({
    queryKey: thoughtKeys.list(request),
    queryFn: () => getThoughts(accessToken, request),
    enabled: Boolean(accessToken) && enabled,
  });
}
